import React from 'react'
import {CatalogModule, moduleLabel} from './catalog'

interface ModuleCheckboxListProps {
  modules: CatalogModule[]
  selected: CatalogModule[]
  disabled?: boolean
  onChange: (selected: CatalogModule[]) => void
}

export const ModuleCheckboxList: React.FC<ModuleCheckboxListProps> = ({
  modules,
  selected,
  disabled = false,
  onChange,
}) => {
  if (modules.length === 0) {
    return <p className='text-muted mb-0'>Your subscription already includes all catalog modules.</p>
  }

  const toggle = (moduleId: CatalogModule) => {
    if (selected.includes(moduleId)) {
      onChange(selected.filter((m) => m !== moduleId))
    } else {
      onChange([...selected, moduleId])
    }
  }

  return (
    <div className='d-flex flex-column gap-2'>
      {modules.map((moduleId) => (
        <div className='form-check mb-0' key={moduleId}>
          <input
            className='form-check-input'
            type='checkbox'
            id={`module-${moduleId}`}
            checked={selected.includes(moduleId)}
            disabled={disabled}
            onChange={() => toggle(moduleId)}
          />
          <label className='form-check-label' htmlFor={`module-${moduleId}`}>
            {moduleLabel(moduleId)}
          </label>
        </div>
      ))}
    </div>
  )
}
